import React from "react";
import clsx from "clsx";
import stylesThankYou from "../ThankYouPage/styles/ThankYouPage.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { ADMIN_ROLE } from "@constants";
import { Button } from "react-bootstrap";

const AccessDenyPage = () => {
  const { login } = useSelector((state) => state.auth);
  return (
    <div className={clsx(stylesThankYou.container)}>
      <span className={clsx(stylesThankYou.mainText)}>Access Denied</span>
      <div className={clsx(stylesThankYou.detailText)}>
        <span className={clsx(stylesThankYou.notiText)}>
          Are you lost, You are not supposed to be here !
        </span>
        <Link to={login.role === ADMIN_ROLE ? "/admin" : "/"}zz>
          <Button style={{ fontWeight: "600" }}>Go To Homepage</Button>
        </Link>
      </div>
    </div>
  );
};

/* required: display name */
AccessDenyPage.displayName = "AccessDenyPage";

/* required: props types */
AccessDenyPage.propTypes = {};

/* required: default props */
AccessDenyPage.defaultProps = {};

export { AccessDenyPage };
